import type { TrustpilotReviewCardProps } from "components/TrustpilotReviewCard";
import TrustpilotReviewCard from "components/TrustpilotReviewCard";

interface TrustpilotReviewAdapterProps {
  blok: TrustpilotReviewCardProps;
}

const TrustpilotReviewAdapter = ({
  blok: { reviewText, author, authorsCountry, rating, avatarSrc },
}: TrustpilotReviewAdapterProps) => (
  <TrustpilotReviewCard
    reviewText={reviewText}
    author={author}
    authorsCountry={authorsCountry}
    rating={rating}
    avatarSrc={avatarSrc}
  />
);

export default TrustpilotReviewAdapter;
